import { Measurement } from '@App/app/entities/layer/measurements/measurement.model';
import { Component } from '@angular/core';
import { BaseLayerPropertiesComponent } from '../base-layer-properties/base-layer-properties.component';

@Component({
  selector: 'app-measurement-properties',
  templateUrl: './measurement-properties.component.html',
})
export class MeasurementPropertiesComponent extends BaseLayerPropertiesComponent<Measurement> {}
